



// export const useApiFetch = (url: string) => {
//     return useFetch(url, useAuthorizedFetch());
// };

export const useUserFetch = <T>(url: string) => {
    const config = useRuntimeConfig();
    return useFetch<T>(url,{
        baseURL: config.public.apiendpoint as string,
    });
};